const SPENDINGS = {
    name: 'Dépense',
    description:
        'Un gestionnaire de dépense permettant de répartir les frais entres différentes personnes.',
    technologies: ['Angular', 'HTML', 'TypeScript', 'CSS', 'IndexedDB', 'AngularMaterial'],
    firstReleaseDate: '25/06/2018'
};

export default SPENDINGS;
